import { Button, Form, message, Radio, Modal } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./auditView.css";
import {
  ParseElementsIntoFormNew,
  getScore,
  getScoreQuestionCount,
  getDateAfterWeek,
} from "../../../../parser";
import AuditDetails from "./auditDetails";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";

import {
  getAuditDetailThunk,
  fetchUserInfoThunk,
  saveAuditThunk,
  submitFeedbackThunk,
  updateFormContentThunk,
  getAuditFormDetailThunk,
} from "../../../store/thunks/auditsThunk";
import CustomLoader from "../../common/customLoader";

import { useDispatch, useSelector } from "react-redux";
import { createAccessMap, hasPermission } from "../../../utils/permissions";
import Unauthorized from "../../layouts/Unauthorized";

const AuditView = ({ children = null, key_elem = "1", nameLink = "" }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [qualityScore, setQualityScore] = useState(0);
  const [auditFormAction, setAuditFormAction] = useState("");
  const [isAuditorImgBroken, setIsAuditorImgBroken] = useState(false);
  const location = useLocation();
  const [form] = Form.useForm();
  const [formValue, setFormValue] = useState({});
  const [formSavingFieldType, setFormSavingFieldType] = useState("");
  const [QMF, setQMF] = useState({});
  const prevData = location?.state;

  const maxScore = getScoreQuestionCount(QMF);
  const [totalScorableQuestions, setTotalScorableQuestions] = useState(0);
  const [achievedScoreCount, setAchievedScoreCount] = useState(0);
  const [fatalNotFatal, setFatalNotFatal] = useState({});
  const [fatalCount, setFatalCount] = useState(0);
  const [notFatalCount, setNotFatalCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [auditCommentMessage, setAuditCommentMessage] = useState("");
  const rawAccess = useSelector((state) => state.auth.access);
  const totalCount = QMF?.elements?.questions?.length;
  const id = location.pathname.split("/")[2];

  const [value, setValue] = useState("");
  const [aID, setAID] = useState("");
  const [tid, setTid] = useState("");
  const [commentStatus, setCommentStatus] = useState("0");
  const onChange = (e) => {
    setValue(e.target.value);
  };
  const [showDiv, setShowDiv] = useState(false);
  const [submitReview, setSubmitReview] = useState(false);
  const onClickReview = () => {
    setAuditReviewFormError({});
    setShowDiv(!showDiv);
  };
  const [showLoader, setShowLoader] = useState(true);
  const [isCritical, setIsCritical] = useState(false);
  const lIUId = secureLocalStorage.getItem("lIUId");
  /*setAuditFormInput state is used to show Perform Audit selected fields on Audit Form*/
  const [auditFormInput, setAuditFormInput] = useState({});
  const [auditReviewFormError, setAuditReviewFormError] = useState("");
  const [auditFormHasWeightage, setAuditFormHasWeightage] = useState("FALSE");
  const [dateCount, setDateCount] = useState(0);

  {
    /*Feedback*/
  }
  const [addAgentFeedback, setAddAgentFeedback] = useState(0);
  const [agentFeedback, setAgentFeedback] = useState("");
  const [addSupervisorFeedback, setAddSupervisorFeedback] = useState(0);
  const [supervisorFeedback, setSupervisorFeedback] = useState("");
  const [auditorProfileImage, setAuditorProfileImage] = useState("");
  const [auditAuditorRole, setAuditAuditorRole] = useState("");
  const [agentProfileImage, setAgentProfileImage] = useState("");
  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");
  const accessMap = useMemo(() => {
    return createAccessMap(rawAccess);
  }, [rawAccess]);

  const hasViewAccess = hasPermission(accessMap, "qMSAuditDetailView", "view");
  const handleCancel = () => {
    setIsModalOpen(false);
    setShowDiv(false);
  };

  const handleOk = (params) => {
    const auditId = id ? id : location.pathname.split("/")[2];
    const lIUId = secureLocalStorage.getItem("lIUId");
    const baseUrl = window.location.origin;
    const auditLink = baseUrl + `/audits/${auditId}`;

    if (params === "sd" || params === "saf") {
      const endpoint = `/audits/submitFeedback/${auditId}`;
      const method = "PUT";
      const payload = {
        role: slsRole,
        type: params,
        auditLink: auditLink,
        supervisorID: lIUId,
      };

      dispatch(
        submitFeedbackThunk({
          id: auditId,
          ...payload,
        }),
      )
        .unwrap()
        .then((response) => {
          setAddSupervisorFeedback(0);
          if (response?.supervisorFeedback) {
            setSupervisorFeedback(
              JSON.parse(response?.supervisorFeedback)?.status,
            );
            setAuditFormInput((prevState) => ({
              ...prevState, // Spread the previous state to retain existing key-value pairs
              "Supervisor Feedback": JSON.parse(response?.supervisorFeedback)
                ?.status,
            }));
          }
        })
        .catch((error) => {
          error?.data?.message && message.error(error?.data?.message);
        });
    } else if (value === "comment" && auditCommentMessage === "") {
      setAuditReviewFormError((state) => ({
        ...state,
        message: auditCommentMessage ? "" : "Comment field is required",
      }));
    } else {
      setAuditReviewFormError({});
      setSubmitReview(true);
      const dateTime = new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

      const endpoint = `/audits/submitFeedback/${auditId}`;
      const method = "PUT";

      const payload = {
        role: slsRole,
        type: "af",
        auditLink: auditLink,
        stage:
          value === "comment"
            ? "Audit request for discussion"
            : "Audit Completed",
        comment: value === "comment" ? 1 : 0,
        message: auditCommentMessage,
        dateTime: dateTime,
        transaction_id: tid,
        agent: lIUId,
        commentStatus: value === "comment" ? "1" : "0",
      };
      dispatch(
        submitFeedbackThunk({
          id: auditId,
          ...payload,
        }),
      )
        .unwrap()
        .then((response) => {
          if (response) {
            setShowDiv(2);
            if (response?.supervisorFeedback) {
              setSupervisorFeedback(
                JSON.parse(response?.supervisorFeedback)?.status,
              );
              setAuditFormInput((prevState) => ({
                ...prevState, // Spread the previous state to retain existing key-value pairs
                "Supervisor Feedback": JSON.parse(response?.supervisorFeedback)
                  ?.status,
              }));
            }
            if (response?.agentFeedback) {
              setAgentFeedback(JSON.parse(response?.agentFeedback)?.status);
              setAuditFormInput((prevState) => ({
                ...prevState, // Spread the previous state to retain existing key-value pairs
                "Agent Feedback": JSON.parse(response?.agentFeedback)?.status,
              }));
            }
            setSubmitReview(false);
            setAddAgentFeedback(0);
          }
        })
        .catch((error) => {
          error?.data?.message && message.error(error?.data?.message);
        });
    }
  };

  // Create an object to store subarrays
  var fatalNotFatalArr = {};

  //begin:: show Audit Form

  const getAuditDetail = async () => {
    if (secureLocalStorage.getItem("auditFormCall") === "performAuditUpdate") {
      const allKeys = Object.keys(localStorage);
      let removeItems;
      removeItems = ["@secure.n.totalAuditedCount"];
      allKeys &&
        allKeys.forEach((key) => {
          if (removeItems && removeItems.includes(key)) {
            localStorage.removeItem(key);
          }
        });
    }

    if (window.performance) {
      const entries = performance.getEntriesByType("navigation");
      if (
        secureLocalStorage.getItem("clickedLink") !== "auditsDetailLinkClick"
      ) {
        if (entries.length > 0 && entries[0].type === "reload") {
          // Page is refreshed
          secureLocalStorage.setItem("clickedLink", "auditsDetailLinkVisit");
        }
      } else {
        if (secureLocalStorage.getItem("auditFormCall") === "performAudit") {
          // Page is refreshed
          secureLocalStorage.setItem("clickedLink", "auditsDetailLinkVisit");
        } else {
        }
      }
    }

    if (secureLocalStorage.getItem("auditFormCall") === "performAudit") {
      secureLocalStorage.removeItem("auditedQuestionCount");
      secureLocalStorage.removeItem("auditedQuestionScoreCount");
      secureLocalStorage.removeItem("timeStampsDetails");
      {
        /*Fetching Auditor Profile Image*/
      }
      if (prevData?.auditorId) {
        const payload = { id: prevData?.auditorId };
        await dispatch(fetchUserInfoThunk(payload))
          .unwrap()
          .then((response) => {
            setAuditorProfileImage({
              name: response?.name,
              profilePicUrl: response?.profilePicUrl
                ? process.env.REACT_APP_BACKEND +
                  "/images/" +
                  response?.profilePicUrl
                : process.env.REACT_APP_BACKEND + "/images/dummy.jpg",
            });
          })
          .catch((error) => {
            error?.data?.message && message.error(error?.data?.message);
          });
      }
      if (prevData?.agentId) {
        const payload = { id: prevData?.agentId };
        await dispatch(fetchUserInfoThunk(payload))
          .unwrap()
          .then((response) => {
            setAgentProfileImage({
              name: response?.name,
              profilePicUrl: response?.profilePicUrl
                ? process.env.REACT_APP_BACKEND +
                  "/images/" +
                  response?.profilePicUrl
                : process.env.REACT_APP_BACKEND + "/images/dummy.jpg",
            });
          })
          .catch((error) => {
            error?.data?.message && message.error(error?.data?.message);
          });
      }
    }

    const resolvedId =
      secureLocalStorage.getItem("savedAuditId") !== null &&
      (secureLocalStorage.getItem("auditFormCall") === null ||
        secureLocalStorage.getItem("auditFormCall") === "performAuditUpdate")
        ? secureLocalStorage.getItem("savedAuditId")
        : id;

    setShowLoader(true);
    try {
      const isPerformAudit =
        secureLocalStorage.getItem("auditFormCall") === "performAudit";

      const action = isPerformAudit
        ? getAuditFormDetailThunk({ id: resolvedId })
        : getAuditDetailThunk({ id: resolvedId });

      const response = await dispatch(action).unwrap();

      if (response?.auditor) {
        setAuditAuditorRole(response?.auditor?.role);
        setAuditorProfileImage({
          name: response?.auditor?.name,
          profilePicUrl: response?.auditor?.profilePicUrl
            ? process.env.REACT_APP_BACKEND +
              "/images/" +
              response?.auditor?.profilePicUrl
            : process.env.REACT_APP_BACKEND + "/images/dummy.jpg",
        });
      }

      if (response?.agent) {
        setAgentProfileImage({
          name: response?.agent?.name,
          profilePicUrl: response?.agent?.profilePicUrl
            ? process.env.REACT_APP_BACKEND +
              "/images/" +
              response?.agent?.profilePicUrl
            : process.env.REACT_APP_BACKEND + "/images/dummy.jpg",
        });
      }

      if (response.supervisorFeedback === null) {
        setAddSupervisorFeedback(1);
      }

      if (response.agentFeedback === null) {
        setAddAgentFeedback(1);
      }

      if (response?.supervisorFeedback) {
        setSupervisorFeedback(JSON.parse(response?.supervisorFeedback)?.status);
      }

      if (response?.agentFeedback) {
        setAgentFeedback(JSON.parse(response?.agentFeedback)?.status);
      }

      if (response?.fatalNotFatalInfo) {
        setFatalCount(JSON.parse(response?.fatalNotFatalInfo)?.fatal);
        setNotFatalCount(JSON.parse(response?.fatalNotFatalInfo)?.notFatal);
      }

      if (response?.auditedScoreInfo) {
        setAchievedScoreCount(
          JSON.parse(response?.auditedScoreInfo)?.auditedQuestionCount,
        );
        setTotalScorableQuestions(
          JSON.parse(response?.auditedScoreInfo)?.auditedMaxQuestionCount,
        );
        setQualityScore(JSON.parse(response?.auditedScoreInfo)?.score);
      }

      secureLocalStorage.removeItem("parameterSelectedList");
      let questions = JSON.parse(response?.formContent)?.elements?.questions;

      let count = 1;
      let dcount = 1;
      let totalWeightage = 0;

      // Initialize subarrays
      fatalNotFatalArr["fatal"] = [];
      fatalNotFatalArr["notFatal"] = [];

      secureLocalStorage.setItem("totalAuditedCount", 0);

      for (let i = 0; i < questions?.length; i++) {
        if (questions[i].meta.weightage) {
          totalWeightage = totalWeightage + questions[i].meta.weightage;
          setAuditFormHasWeightage("TRUE");
        }
        if (questions[i].input_type === "radio-group") {
          if (!response?.auditedScoreInfo) {
            setTotalScorableQuestions(count);
          }
          secureLocalStorage.setItem("totalAuditedCount", count++);
        }

        if (questions[i].input_type === "date") {
          setDateCount(dcount++);
        }
        if (questions[i].meta?.critical === true) {
          if (questions[i].qkey) {
            fatalNotFatalArr["fatal"].push(questions[i].qkey);
          }
        } else {
          if (questions[i].qkey) {
            fatalNotFatalArr["notFatal"].push(questions[i].qkey);
          }
        }
        if (questions[i].selectedValue && questions[i].selectedValue !== "") {
          setFormValue((state) => ({
            ...state,
            [questions[i].qkey]: [
              questions[i].selectedValue,
              questions[i].meta.isQualityMetric,
              questions[i].meta.weightage,
              totalWeightage,
            ],
          }));
        }
      }

      setFatalNotFatal(fatalNotFatalArr);

      setAuditFormInput(secureLocalStorage.getItem("auditFormInput"));
      if (secureLocalStorage.getItem("auditFormCall") !== "performAudit") {
        setAuditFormInput((prev) => ({
          ...prev,
          Stage: { icon: "auditStag", value: response?.stage },
          Auditor: { icon: "auditAuditor", value: response?.auditor?.name },
          "Audit Score": {
            icon: "auditScoree",
            value: response?.auditedScoreInfo?.score,
          },
          Client: { icon: "auditClient", value: response?.client?.name },
          Department: {
            icon: "auditDepartment",
            value: response?.department?.name,
          },
          Process: { icon: "auditProcess", value: response?.process?.name },
          "Audit Form": {
            icon: "auditForm",
            value: response?.auditForm?.formName,
          },
          Transaction: {
            icon: "auditTransaction",
            value: response?.transaction_id,
          },
          Status: {
            icon: "departmentStatus",
            value: response?.status?.toString(),
          },
          agent: {
            icon: "auditAgent",
            value:
              response?.agent?.name +
              " (Emp ID: " +
              response?.agent?.empID +
              ")",
          },
        }));

        if (response?.auditBackDateReason) {
          setAuditFormInput((prevState) => ({
            ...prevState, // Spread the previous state to retain existing key-value pairs
            "Reason for Audit's back date": {
              icon: "auditAgent",
              value: response?.auditBackDateReason,
            },
          }));
        }
        if (response?.transactionDuplicateReason) {
          setAuditFormInput((prevState) => ({
            ...prevState, // Spread the previous state to retain existing key-value pairs
            "Reason for duplicate Transaction ID": {
              icon: "auditAgent",
              value: response?.transactionDuplicateReason,
            },
          }));
        }
        if (response?.insuredName) {
          setAuditFormInput((prevState) => ({
            ...prevState, // Spread the previous state to retain existing key-value pairs
            "Insured Name": {
              icon: "auditInsure",
              value: response?.insuredName,
            },
          }));
        }
        if (response?.transactionAmount) {
          setAuditFormInput((prevState) => ({
            ...prevState, // Spread the previous state to retain existing key-value pairs
            "Transaction Amount": {
              icon: "auditTransaction",
              value: response?.transactionAmount,
            },
          }));
        }
        if (response?.invoiceCount) {
          setAuditFormInput((prevState) => ({
            ...prevState, // Spread the previous state to retain existing key-value pairs
            "Invoice Count": {
              icon: "auditInsure",
              value: response?.invoiceCount,
            },
          }));
        }
        if (response?.agentFeedback) {
          setAuditFormInput((prevState) => ({
            ...prevState, // Spread the previous state to retain existing key-value pairs
            "Agent Feedback": JSON.parse(response?.agentFeedback)?.status,
          }));
        }
        if (response?.supervisorFeedback) {
          setAuditFormInput((prevState) => ({
            ...prevState, // Spread the previous state to retain existing key-value pairs
            "Supervisor Feedback": {
              icon: "auditInsure",
              value: JSON.parse(response?.supervisorFeedback)?.status,
            },
          }));
        }
        secureLocalStorage.setItem("timeStampsDetails", {
          CreatedAt: response?.createdAt,
          UpdatedAt: response?.updatedAt,
        }); //For showing TimeStamp Details on View Audit after saving

        secureLocalStorage.setItem("savePayloadRequestParams", {
          clientId: response?.client?._id,
          departmentId: response?.department?._id,
          processId: response?.process?._id,
          transactionId: response?.transaction_id,
          transactionDate: response?.transactionDate,
          agentId: response?.agent?._id,
          formContent: response?.formContent,
          Stage: response?.stage.toString(),
          auditForm: response?.auditForm?._id,
          score: response?.auditedScoreInfo?.score,
          auditedQuestionCount: response?.auditedQuestionCount,
          transactionDuplicateReason: response?.transactionDuplicateReason,
          auditDeleteReason: response?.auditDeleteReason,
          auditStatus: response?.status,
          auditBackDateReason: response?.auditBackDateReason,
          insuredName: response?.insuredName,
          transactionAmount: response?.transactionAmount,
          invoiceCount: response?.invoiceCount,
          aditorID: response?.auditor?._id,
        }); //For sending audit details for auto save on change
        secureLocalStorage.setItem("aID", response?.agent?._id);

        setAID(response?.agent?._id);
        setTid(response?.transaction_id);
        setCommentStatus(response?.commentStatus);
        secureLocalStorage.setItem(
          "auditScore",
          secureLocalStorage.getItem("savePayloadRequestParams")?.score,
        );
        secureLocalStorage.setItem(
          "auditedQuestionCount",
          secureLocalStorage.getItem("savePayloadRequestParams")
            ?.auditedQuestionCount,
        );

        secureLocalStorage.setItem("auditedFormSubmit", false);
        if (response?.stage.toString() === "Audit Completed") {
          secureLocalStorage.setItem("auditedFormSubmit", true);
        }
      }

      if (id && secureLocalStorage.getItem("savePayloadRequestParams")) {
        var parsedQMF = JSON.parse(
          secureLocalStorage.getItem("savePayloadRequestParams")?.formContent,
        );

        setQMF(parsedQMF);
        setShowLoader(false);
      } else {
        if (secureLocalStorage.getItem("updatedQMF")) {
          let parsedQMF = secureLocalStorage.getItem("updatedQMF")?.formContent;
          setQMF(parsedQMF);
          setShowLoader(false);
        } else {
          let parsedQMF = JSON.parse(response.formContent);
          setQMF(parsedQMF);
          setShowLoader(false);
        }
      }
    } catch (error) {
      error?.data?.message && message.error(error?.data?.message);
    } finally {
      setShowLoader(false); // ✅ GUARANTEED
    }
  };

  const performAudit = (prop) => {
    if (
      secureLocalStorage.getItem("savePayloadRequestParams")?.Stage !==
      "Audit Completed"
    ) {
      let action;
      let createdBy = null;
      let updatedBy = null;
      let createdAt = "";
      let updatedAt = "";
      let auditMethod;
      let savePayloadRequestParams;
      let auditStage = "Audit Pending";
      let auditStatus = "ACTIVE";
      let auditLink = "";
      const auditedQuestionCount = secureLocalStorage.getItem(
        "auditedQuestionCount",
      )
        ? secureLocalStorage.getItem("auditedQuestionCount")
        : Object.keys(formValue).length;
      const score = secureLocalStorage.getItem("auditScore")
        ? secureLocalStorage.getItem("auditScore")
        : qualityScore;

      const totalQuestionCount = totalCount;

      if (id && secureLocalStorage.getItem("savePayloadRequestParams")) {
        //On refresh after marking anything from the checklist of the audit or visiting to audit from listing

        savePayloadRequestParams = secureLocalStorage.getItem(
          "savePayloadRequestParams",
        );
        auditMethod = "PUT";
        createdAt = secureLocalStorage.getItem(
          "savePayloadRequestParams",
        )?.createdAt;

        updatedAt = new Date(
          new Date().getTime() - new Date().getTimezoneOffset() * 60000,
        )
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        updatedBy = lIUId;
        action = `/audits/${
          secureLocalStorage.getItem("savedAuditId") !== null &&
          (secureLocalStorage.getItem("auditFormCall") === null ||
            secureLocalStorage.getItem("auditFormCall") ===
              "performAuditUpdate") &&
          secureLocalStorage.getItem("fromComponent") !== "audits"
            ? secureLocalStorage.getItem("savedAuditId")
            : id
        } `;
      } else {
        if (secureLocalStorage.getItem("auditFormCall") === "performAudit") {
          //Create - Visiting here from Perform an audit form
          auditMethod = "POST";
          createdAt = new Date(
            new Date().getTime() - new Date().getTimezoneOffset() * 60000,
          )
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          createdBy = lIUId;
          action = `/audits`;
          secureLocalStorage.setItem("auditFormCall", "performAuditUpdate"); //To stop further PUT audit method
          secureLocalStorage.removeItem("timeStampsDetails");
          secureLocalStorage.setItem("timeStampsDetails", {
            CreatedAt: createdAt,
          });
          secureLocalStorage.setItem("weightageFlag", 0);
        } else {
          //Update - Without refreshing and marking anything from the checklist of the audit
          savePayloadRequestParams = secureLocalStorage.getItem(
            "savePayloadRequestParams",
          );
          auditMethod = "PUT";
          createdAt =
            secureLocalStorage.getItem("timeStampsDetails")?.CreatedAt;
          updatedAt = new Date(
            new Date().getTime() - new Date().getTimezoneOffset() * 60000,
          )
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          updatedBy = lIUId;
          action = `/audits/${
            secureLocalStorage.getItem("savedAuditId") !== null &&
            secureLocalStorage.getItem("auditFormCall") === "performAuditUpdate"
              ? secureLocalStorage.getItem("savedAuditId")
              : id
          }`;

          secureLocalStorage.setItem("timeStampsDetails", {
            CreatedAt: createdAt,
            UpdatedAt: updatedAt,
          });
        }
      }

      if (prop === "finish") {
        auditStage = "Audit Completed";
        auditStatus = "CLOSED";
        const baseUrl = window.location.origin;
        auditLink =
          baseUrl +
          `/audits/${
            secureLocalStorage.getItem("savedAuditId") !== null
              ? secureLocalStorage.getItem("savedAuditId")
              : id
          }`;
        secureLocalStorage.setItem("auditFormSubmit", true);
      }

      const fatalNotFatalInfo = {
        fatal: fatalCount,
        notFatal: notFatalCount,
      };

      const auditedScoreInfo = {};

      auditedScoreInfo.auditedQuestionCount = achievedScoreCount
        ? achievedScoreCount
        : 0;
      auditedScoreInfo.auditedMaxQuestionCount =
        totalScorableQuestions && totalScorableQuestions;
      auditedScoreInfo.score = score && score.toString();
      auditedScoreInfo.actualScore = score && score.toString();
      auditedScoreInfo.maxScore = score && score.toString();
      auditedScoreInfo.totalQuestionCount =
        totalQuestionCount && totalQuestionCount;

      const auditPayload = {
        role: slsRole,
        client: savePayloadRequestParams
          ? savePayloadRequestParams?.clientId
          : prevData?.clientId,
        department: savePayloadRequestParams
          ? savePayloadRequestParams?.departmentId
          : prevData?.departmentId,
        process: savePayloadRequestParams
          ? savePayloadRequestParams?.processId
          : prevData?.processId,
        auditForm: savePayloadRequestParams
          ? savePayloadRequestParams?.auditForm
          : location.pathname.split("/")[2],
        transaction_id: savePayloadRequestParams
          ? savePayloadRequestParams?.transactionId
          : prevData?.transactionId,
        transactionDate: savePayloadRequestParams
          ? savePayloadRequestParams?.transactionDate
          : prevData?.transactionDte,
        transactionDuplicateReason: savePayloadRequestParams
          ? savePayloadRequestParams?.transactionDuplicateReason
          : prevData?.transactionDuplicateReason,
        auditBackDateReason: savePayloadRequestParams
          ? savePayloadRequestParams?.auditBackDateReason
          : prevData?.auditBackDateReason,
        agent: savePayloadRequestParams
          ? savePayloadRequestParams?.agentId
          : prevData?.agentId,
        auditor: lIUId,
        auditFor: location.state?.auditFor || "agent",
        stage: auditStage,
        status: auditStatus,
        auditedQuestionCount: auditedQuestionCount,
        totalQuestionCount: totalQuestionCount,
        auditedScoreInfo: auditedScoreInfo && JSON.stringify(auditedScoreInfo),
        fatalNotFatalInfo:
          fatalNotFatalInfo && JSON.stringify(fatalNotFatalInfo),
        score: score && score.toString(),
        createdBy: createdBy,
        updatedBy: updatedBy,
        createdAt: createdAt,
        updatedAt: updatedAt,
        formContent: QMF,
        auditLink: auditLink,
        hasWeightage: auditFormHasWeightage,
        insuredName: savePayloadRequestParams
          ? savePayloadRequestParams?.insuredName
          : prevData?.insuredName,
        transactionAmount: savePayloadRequestParams
          ? savePayloadRequestParams?.transactionAmount
          : prevData?.transactionAmount,
        invoiceCount: savePayloadRequestParams
          ? savePayloadRequestParams?.invoiceCount
          : prevData?.invoiceCount,
      };
      dispatch(
        saveAuditThunk({
          ...(auditMethod === "PUT" && {
            id:
              secureLocalStorage.getItem("savedAuditId") !== null
                ? secureLocalStorage.getItem("savedAuditId")
                : id,
          }),
          ...auditPayload,
        }),
      )
        .unwrap()
        .then((response) => {
          var parsedQMF = JSON.parse(response.formContent);
          let auditForm = response.auditForm;
          secureLocalStorage.setItem("updatedQMF", {
            id: auditForm,
            formContent: parsedQMF,
          });

          secureLocalStorage.setItem("savedAuditId", response?._id);

          if (secureLocalStorage.getItem("auditedFormSubmit") === true) {
            navigate("/audits");
          }
        })
        .catch((error) => {
          error?.data?.message && message.error(error?.data?.message);
        });
    }
  };

  const getValue = (value, id, isQualityMetric, weightage, serial_no) => {
    if (
      (slsRole === "admin" ||
        slsRole === "auditor" ||
        slsRole === "qc" ||
        slsRole === "am" ||
        slsRole === "tl" ||
        slsRole === "atl") &&
      ((secureLocalStorage.getItem("auditFormCall") !== "performAudit" &&
        (secureLocalStorage.getItem("savePayloadRequestParams")?.aditorID ===
          secureLocalStorage.getItem("lIUId") ||
          prevData?.auditorId === secureLocalStorage.getItem("lIUId"))) ||
        (secureLocalStorage.getItem("auditFormCall") === "performAudit" &&
          prevData?.auditorId === secureLocalStorage.getItem("lIUId")))
    ) {
      /*begin::Set array in the way user audited the parameters of the Audit Form*/
      if (value === "Yes" || value === "No" || value === "Not Applicable") {
        if (secureLocalStorage.getItem("parameterSelectedList")) {
          let parameterSelectedList = secureLocalStorage.getItem(
            "parameterSelectedList",
          );

          if (!parameterSelectedList.includes(id)) {
            parameterSelectedList.unshift(id);
          } else {
            parameterSelectedList = parameterSelectedList.filter(
              (x) => x !== id,
            );
            parameterSelectedList.unshift(id);
          }
          secureLocalStorage.setItem(
            "parameterSelectedList",
            parameterSelectedList,
          );
        } else {
          secureLocalStorage.setItem("parameterSelectedList", [id]);
        }
      } else {
        setFormSavingFieldType("others");
      }
      /*end::Set array in the way user audited the parameters of the Audit Form*/

      var questions = QMF?.elements?.questions;
      let totalWeightage = 0; //Variable to store overall weightage of audit form having parameter's weightage
      let aQCount = 1;
      let aQSCount = 1;
      let countQA = []; //Variable to store all user audited parameter's value
      let isCriticalParameterHasNo = false;

      for (let i = 0; i < questions?.length; i++) {
        if (questions[i]?.qkey === id) {
          questions[i].selectedValue = value; //This is setting value in new property selectedValue
        }

        //Setting variable flag if it is critical parameter
        if (
          questions[i]?.meta?.required === true &&
          questions[i].selectedValue === "No"
        ) {
          isCriticalParameterHasNo = true;
        }
        if (questions[i].meta.weightage) {
          totalWeightage = totalWeightage + questions[i].meta.weightage;
          setAuditFormHasWeightage("TRUE");
        }
        if (questions[i].input_type === "radio-group") {
          switch (questions[i].selectedValue) {
            case "Yes":
              secureLocalStorage.setItem(
                "auditedQuestionScoreCount",
                aQCount++,
              );
              countQA.push("Yes");
              break;
            case "No":
              countQA.push("No");
              break;
            case "Not Applicable":
              countQA.push("NotApplicable");
              if (secureLocalStorage.getItem("auditedQuestionScoreCount")) {
                if (
                  secureLocalStorage.getItem("auditedQuestionScoreCount") ===
                    1 &&
                  value === "Not Applicable" &&
                  auditFormHasWeightage === "TRUE"
                ) {
                  secureLocalStorage.setItem("auditedQuestionScoreCount", "0");
                }
              } else {
                secureLocalStorage.setItem("auditedQuestionScoreCount", "0");
              }
              break;

            default:
              break;
          }
        }

        if (questions[i].selectedValue && questions[i].selectedValue !== "") {
          secureLocalStorage.setItem("auditedQuestionCount", aQSCount++); //Setting for showing audited count for all questions of audit
        }
      }

      let fatalErrorCount = {};
      let nonFatalErrorCount = {};
      for (let i = 0; i < questions?.length; i++) {
        const key = questions[i]?.qkey;

        if (
          questions[i]?.meta?.critical === true &&
          questions[i]?.selectedValue === "No"
        ) {
          fatalErrorCount[key] = "No";
        }
        if (
          questions[i]?.meta?.critical === false &&
          questions[i]?.selectedValue === "No"
        ) {
          nonFatalErrorCount[key] = "No";
        }
      }

      setFatalCount(fatalErrorCount && Object.keys(fatalErrorCount).length);
      setNotFatalCount(
        nonFatalErrorCount && Object.keys(nonFatalErrorCount).length,
      );
      let countMap = {};
      countQA.forEach(function (i) {
        countMap[i] = (countMap[i] || 0) + 1;
      });
      if (countMap.NotApplicable) {
        setAchievedScoreCount(
          countQA && countQA.length - countMap.NotApplicable,
        );
        setTotalScorableQuestions(maxScore - countMap.NotApplicable);
      } else {
        setAchievedScoreCount(countQA && countQA.length);
        setTotalScorableQuestions(maxScore);
      }
      setIsCritical(isCriticalParameterHasNo);

      if (auditFormHasWeightage === "FALSE" && countMap.No) {
        if (countMap.Yes) {
          setAchievedScoreCount(countMap && countMap.Yes);
        } else {
          setAchievedScoreCount(0);
        }
      }
      secureLocalStorage.setItem("countMap", countMap);

      if (value === "Yes" || value === "No" || value === "Not Applicable") {
        secureLocalStorage.setItem("clickedLink", "onChange");
      } else {
        secureLocalStorage.setItem("clickedLink", "textOnChangeRequest");
      }

      if (
        secureLocalStorage.getItem("savePayloadRequestParams")?.Stage !==
        "Audit Completed"
      ) {
        setFormValue({
          ...formValue,
          [id]: [
            value,
            isQualityMetric,
            weightage,
            totalWeightage,
            "",
            isCriticalParameterHasNo,
          ],
        });
      } else {
        if (
          currentDateTimeStamp < dateAfterAuditedDateTimeStamp &&
          id === "correction-user" &&
          secureLocalStorage.getItem("savePayloadRequestParams")?.Stage ===
            "Audit Completed" &&
          location?.state?.formMethd === "update" &&
          slsRole === "auditor"
        ) {
          setFormValue({
            ...formValue,
            [id]: [
              value,
              isQualityMetric,
              weightage,
              totalWeightage,
              isCriticalParameterHasNo,
            ],
          });
          let updatedAt = new Date(
            new Date().getTime() - new Date().getTimezoneOffset() * 60000,
          )
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          let updatedBy = lIUId;

          let action = `/audits/updateFormContent/${
            location?.pathname?.split("/")?.[2]
          }`;

          const method = "PUT";
          const payload = {
            role: slsRole,
            updatedBy: updatedBy,
            updatedAt: updatedAt,
            formContent: QMF,
          };
          dispatch(
            updateFormContentThunk({
              id: location?.pathname?.split("/")?.[2],
              updatedBy,
              updatedAt,
              formContent: QMF,
            }),
          )
            .unwrap()
            .then((response) => {})
            .catch((error) => {
              error?.data?.message && message.error(error?.data?.message);
            });
        }
      }

      if (auditFormAction === "") {
        setAuditFormAction("create");
        if (qualityScore !== 0) {
          performAudit();
        }
      } else {
        setAuditFormAction("update");
      }
    }
  };

  /*begin::Submit Audit button functionality*/
  const onFinish = () => {
    setAuditFormAction("update");
    performAudit("finish");
    message.success("Submit success!");
    secureLocalStorage.setItem("auditedFormSubmit", true);
  };
  const filledRequiredQuestions =
    QMF?.elements?.questions?.filter(q => {
        if (q.input_type === "date") return false;

        return (
            q.meta?.required &&
            q.selectedValue !== undefined &&
            q.selectedValue !== ""
        );
    }).length;

  const onFinishFailed = () => {
  
    (Number(qualityScore) < 100 &&
      tCountForAlertMessage ===
        secureLocalStorage.getItem("auditedQuestionCount")) ||
    (Number(qualityScore) === 100 &&
      achievedScoreCount === totalScorableQuestions)
      ? message.error("Submission failed!")
      : message.error(
          "Submission failed because the score is less than 100, and kindly fill all observation questions!",
        );
  };
  const onFinishFailed1 = () => {
    const auditedCount = Number(
      secureLocalStorage.getItem("auditedQuestionCount"),
    );

    const mandatoryQuestionsCount =
      QMF?.elements?.questions?.filter(
        (q) => q.meta?.required === true && q.input_type === "radio-group",
      ).length || 0;

    const isSubmissionValid =
      (Number(qualityScore) < 100 &&
        mandatoryQuestionsCount === auditedCount) ||
      (Number(qualityScore) === 100 &&
        achievedScoreCount === totalScorableQuestions);

    if (isSubmissionValid) {
      message.error("Submission failed!");
    } else {
      message.error(
        "Submission failed because the score is less than 100, and a mandatory question with an asterisk (*) is still unanswered!",
      );
    }
    // (Number(qualityScore) < 100 &&
    //   tCountForAlertMessage ===
    //     auditedCount) ||
    // (Number(qualityScore) === 100 &&
    //   achievedScoreCount === totalScorableQuestions)
    //   ? message.error("Submission failed!")
    //   : message.error(
    //       "Submission failed because the score is less than 100, and a mandatory question with an asterisk (*) is still unanswered!",
    //     );
  };
  /*end::Submit Audit button functionality*/

  const currentDateTimeStamp = new Date(new Date()).getTime();
  const dateAfterAuditedDateTimeStamp =
    secureLocalStorage.getItem("timeStampsDetails") &&
    getDateAfterWeek(
      moment(secureLocalStorage.getItem("timeStampsDetails")?.CreatedAt).format(
        "YYYY-MM-DD",
      ),
      "timeStamp",
    );

  const [tCountForAlertMessage, setTCountForAlertMessage] = useState("");

  const feedbackParts = [];
  // Agent feedback
  if (
    slsRole === "admin" ||
    slsRole === "am" ||
    slsRole === "tl" ||
    slsRole === "atl"
  ) {
    feedbackParts.push(
      addAgentFeedback === 0 && agentFeedback
        ? `Agent : ${agentFeedback}`
        : "Agent : Awaited",
    );
  }
  // Supervisor feedback
  if (
    (slsRole === "admin" || slsRole === "agent") &&
    agentFeedback &&
    agentFeedback !== "Accepted"
  ) {
    feedbackParts.push(
      addSupervisorFeedback === 0 && supervisorFeedback
        ? `Supervisor : ${supervisorFeedback}`
        : "Supervisor : Awaited",
    );
  }
  const divStructure = secureLocalStorage.getItem("savePayloadRequestParams")
    ?.Stage !== "" &&
    Number(qualityScore) < 100 && (
      <span className="feedback-content">
        {(((slsRole === "tl" || slsRole === "am") &&
          (addAgentFeedback === 1 || agentFeedback || supervisorFeedback)) ||
          (slsRole === "agent" &&
            (addAgentFeedback === 0 || agentFeedback || supervisorFeedback) &&
            agentFeedback != "Accepted")) && (
          <>
            <strong>Feedback | </strong>{" "}
          </>
        )}

        {feedbackParts.join(", ")}
      </span>
    );

  const headLine = QMF?.elements?.meta?.headline;
  const singlePageContent = { divStructure, headLine };

  useEffect(() => {
    /*Begin::Auto Save functionality onChange*/
    if (auditFormAction === "create") {
      if (formSavingFieldType === "") {
        setQualityScore(
          getScore(
            formValue,
            totalScorableQuestions,
            auditFormHasWeightage,
            "",
            isCritical,
          ),
        );
      }
      if (secureLocalStorage.getItem("auditScore") !== 0) {
        performAudit();
      }
    }
    if (auditFormAction === "update") {
      if (formSavingFieldType === "") {
        setQualityScore(
          getScore(
            formValue,
            totalScorableQuestions,
            auditFormHasWeightage,
            "",
            isCritical,
          ),
        );
      }
      if (
        secureLocalStorage.getItem("auditScore") !== qualityScore ||
        secureLocalStorage.getItem("auditScore") === qualityScore
      ) {
        performAudit();
      }
    }
    /*End::Auto Save functionality onChange*/
  }, [formValue]);

  useEffect(() => {
    getAuditDetail();
  }, [location.pathname]);

  useEffect(() => {
    if (Number(qualityScore) < 100) {
      // Select all elements with the class 'text123'
      const elementsWithText123 = document.querySelectorAll(
        ".auditFormField .ant-form-item-control-input .ant-form-item-control-input-content",
      );

      // Loop through the selected elements and add an asterisk to each
      elementsWithText123.forEach((element) => {
        const specificChild = element.querySelector(".ant-radio-group");
        const text123Child = element.querySelector(".text123");

        if (!specificChild) {
          // Check if the next element is already an asterisk element
          const nextElement = text123Child?.nextElementSibling;
          if (
            nextElement &&
            nextElement.classList.contains("lessScoreMandatoryFields")
          ) {
            return; // Return early if the asterisk span already exists
          }

          // Create a span element with the asterisk symbol
          const asteriskSpan = document.createElement("span");
          asteriskSpan.innerText = " *";
          asteriskSpan.style.color = "red";
          asteriskSpan.classList.add("lessScoreMandatoryFields"); // Remove the = sign

          text123Child?.parentNode.insertBefore(
            asteriskSpan,
            text123Child?.nextSibling,
          );

          const questionText = element.querySelector(".questionText");
          const numberInput = element.querySelector(
            'input[type="number"].text123'
          );

          if (
            questionText &&
            numberInput &&
            asteriskSpan.parentElement !== questionText
          ) {
            questionText.appendChild(asteriskSpan);
          }
        }
      });
    }
    if (Number(qualityScore) === 100) {
      // Select all spans with the class 'lessScoreMandatoryFields'
      const spansToRemove = document.querySelectorAll(
        ".lessScoreMandatoryFields",
      );

      // Loop through the selected spans and remove them
      spansToRemove.forEach((span) => {
        span.remove();
      });
    }
  }, [qualityScore]);

  // useEffect(() => {
  //   if (!auditAuditorRole) return;
  //   if (secureLocalStorage.getItem("auditType")) {
  //     return;
  //   }
  //   const slsRole = secureLocalStorage.getItem("role");

  //   let auditType = "";

  //   if (slsRole === process.env.REACT_APP_TLROLE) {
  //     auditType =
  //       auditAuditorRole === process.env.REACT_APP_TLROLE ? "ops" : "auditors";
  //   } else if (slsRole === process.env.REACT_APP_QC) {
  //     auditType =
  //       auditAuditorRole === process.env.REACT_APP_AUDROLE
  //         ? "auditors"
  //         : "supervisors";
  //   } else if (slsRole === process.env.REACT_APP_AROLE) {
  //     if (auditAuditorRole === process.env.REACT_APP_AROLE) {
  //       auditType = "ops";
  //     } else if (auditAuditorRole === process.env.REACT_APP_AUDROLE) {
  //       auditType = "auditors";
  //     } else {
  //       auditType = "auditors";
  //     }
  //   }

  //   secureLocalStorage.setItem("auditType", auditType);
  // }, [auditAuditorRole]);

  const [reviewPopupOpen, setReviewPopupOpen] = useState(false);

  const isAuditSubmitted =
    secureLocalStorage.getItem("auditedFormSubmit") === true ||
    secureLocalStorage.getItem("auditedFormSubmit") === "true";

  const isFeedbackSubmitted =
    agentFeedback ||
    supervisorFeedback ||
    addAgentFeedback === 0 ||
    addSupervisorFeedback === 0;

  const isFeedbackActionTriggered =
    submitReview || value === "Accepted" || value === "Disputed";

  const showAuditedVInfo =
    isAuditSubmitted || isFeedbackSubmitted || isFeedbackActionTriggered;

  const isAuditRoute =
    location?.state?.route === "/audits" ||
    location?.pathname.split("/")?.[1] === "audits";

  const submitAuditCondition =
    slsRole !== "agent" &&
    secureLocalStorage.getItem("auditedFormSubmit") !== true &&
    ((secureLocalStorage.getItem("auditFormCall") !== "performAudit" &&
      (secureLocalStorage.getItem("savePayloadRequestParams")?.aditorID ===
        secureLocalStorage.getItem("lIUId") ||
        prevData?.auditorId === secureLocalStorage.getItem("lIUId"))) ||
      (secureLocalStorage.getItem("auditFormCall") === "performAudit" &&
        prevData?.auditorId === secureLocalStorage.getItem("lIUId")));

  if (!hasViewAccess) {
    return <Unauthorized />;
  }
  return (
    <div className="single-page auditViewPreview">
      {secureLocalStorage.getItem("savePayloadRequestParams")?.auditStatus ===
        "SOFTDELETE" &&
      secureLocalStorage.getItem("savePayloadRequestParams")
        ?.auditDeleteReason ? (
        <>
          <div className="backContainer">
            <span className="">
              <span
                className="back-btn"
                onClick={() => {
                  navigate("/audits");
                }}
              >
                Back{" "}
              </span>
            </span>
          </div>
          <div className="center-container">
            <h1 className="centered-text">
              The audit has been removed from the data.
            </h1>
          </div>
        </>
      ) : (
        <>
          <CustomLoader showLoader={showLoader} />
          <div className="auditFormTitlebar pb-16">
            <h2>{singlePageContent?.headLine}</h2>

            <ul className="auditedDetails">
              <li>{singlePageContent.divStructure}</li>
              <li>
                <img
                  src={
                    !isAuditorImgBroken && auditorProfileImage?.profilePicUrl
                      ? auditorProfileImage?.profilePicUrl
                      : process.env.REACT_APP_BACKEND + "/images/dummy.jpg"
                  }
                  alt={auditorProfileImage?.name}
                  title={auditorProfileImage?.name}
                  onError={() => setIsAuditorImgBroken(true)}
                />
                <span>
                  Audited:{" "}
                  <span className="greyBackground">
                    {achievedScoreCount}/{totalScorableQuestions}
                  </span>
                </span>
              </li>

              <li>
                <span>
                  Score: <span className="greyBackground">{qualityScore}%</span>
                </span>
              </li>
            </ul>
          </div>
          <div className="auditFormsDetailsRS plr-16">
            <div className="auditFormsWrapper">
              {hasPermission(
                accessMap,
                "qMSAuditDetailView",
                "auditDetailAuditSectionView",
              ) && (
                <div className="auditFormsWrapperCol">
                  <h3>Audit</h3>
                  <Form
                    id="myform"
                    form={form}
                    layout="vertical"
                    className="cusComprehensiveForm"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    scrollToFirstError
                  >
                    {QMF && ParseElementsIntoFormNew(QMF, getValue)}
                  </Form>
                </div>
              )}

              {/*begin::To show Audit Details in right sidebar*/}
              {hasPermission(
                accessMap,
                "qMSAuditDetailView",
                "auditDetailAuditDetailsSectionView",
              ) && (
                <div className="auditFormsWrapperCol">
                  <AuditDetails
                    auditFormInput={auditFormInput}
                    fatalNotFatalInfo={{
                      fatal: { icon: "auditFatel", value: fatalCount },
                      notFatal: { icon: "auditNoFatel", value: notFatalCount },
                    }}
                    timeStampsDetails={secureLocalStorage.getItem(
                      "timeStampsDetails",
                    )}
                    qualityScore={qualityScore}
                    auditorProfileImage={auditorProfileImage}
                    agentProfileImage={agentProfileImage}
                  />
                </div>
              )}
              {/*end::To show Audit Details in right sidebar*/}
            </div>
          </div>
          {/*Audited and Feedback Section*/}
          {isAuditRoute && (
            <div className="auditedVInfo">
              <div className="feedback-send-container">
                {submitAuditCondition && (
                  <Button
                    className="audit-detail-buttons defaultBtn "
                    onClick={() => {
                      let tCount = totalCount;
                      if (dateCount) {
                        tCount = totalCount - dateCount;
                        setTCountForAlertMessage(tCount);
                      }

                      (Number(qualityScore) < 100 &&
                        tCount ===
                          secureLocalStorage.getItem("auditedQuestionCount")) ||
                      (Number(qualityScore) === 100 &&
                        achievedScoreCount === totalScorableQuestions)
                        ? onFinish()
                        : onFinishFailed();
                    }}
                  >
                    Submit Audit
                  </Button>
                )}
                {(slsRole === "am" ||
                  slsRole === "tl" ||
                  slsRole === "atl" ||
                  slsRole === "agent") && (
                  <>
                    {slsRole === "am" ||
                    slsRole === "tl" ||
                    slsRole === "atl" ? (
                      <div class="modalBtns">
                        {addAgentFeedback === 0 &&
                          addSupervisorFeedback === 1 &&
                          agentFeedback != "Accepted" && (
                            <>
                              <Button
                                className="audit-detail-buttons dispute-btn  defaultBtn defaultGreyBtn"
                                onClick={() => handleOk("sd")}
                              >
                                Dispute
                              </Button>
                              <Button
                                className="audit-detail-buttons acceptFeedbackbtn  defaultBtn"
                                onClick={() => handleOk("saf")}
                              >
                                Accept Feedback
                              </Button>
                            </>
                          )}
                      </div>
                    ) : (
                      <>
                        <Modal
                          open={showDiv}
                          title="Feedback"
                          width={500}
                          className="reviewAuditPopupModal"
                          onCancel={() => setShowDiv(false)}
                          footer={
                            <div className="modalBtns">
                              {submitReview ? (
                                <Button
                                  className="defaultBtn"
                                  type="primary"
                                  loading
                                >
                                  Please wait...
                                </Button>
                              ) : (
                                <>
                                  <Button
                                    type="primary"
                                    onClick={() => handleOk("")}
                                    className="defaultBtn"
                                  >
                                    Submit
                                  </Button>

                                  <Button
                                    className="defaultBtn defaultGreyBtn"
                                    onClick={() => {
                                      setIsModalOpen(false);
                                      setShowDiv(false);
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </>
                              )}
                            </div>
                          }
                        >
                          <div className="pb-16">
                            {/* ===== Modal Body ===== */}
                            {value === "comment" && (
                              <>
                                <textarea
                                  className={`text__area ${
                                    auditReviewFormError?.message ? "error" : ""
                                  }`}
                                  placeholder="Add comment here"
                                  onChange={(e) => {
                                    if (e.target.value !== "") {
                                      setAuditReviewFormError({});
                                    } else {
                                      setAuditReviewFormError({
                                        message: "Review field is required",
                                      });
                                    }
                                    setAuditCommentMessage(e.target.value);
                                  }}
                                  style={{
                                    marginBottom: "15px",
                                    width: "100%",
                                    backgroundColor: "#F0F0F0",
                                  }}
                                  rows={5}
                                />

                                {auditReviewFormError?.message && (
                                  <span className="error">
                                    {auditReviewFormError.message}
                                  </span>
                                )}
                              </>
                            )}

                            <Radio.Group onChange={onChange} value={value}>
                              <Radio value="Accepted">Accept</Radio>
                              <br />

                              {(slsRole === "am" ||
                                slsRole === "tl" ||
                                slsRole === "atl") && (
                                <>
                                  <Radio value="Disputed">Raise Dispute</Radio>
                                  <br />
                                </>
                              )}

                              {slsRole === "agent" && (
                                <>
                                  <Radio value="comment">
                                    Requires discussion
                                  </Radio>
                                  <br />
                                </>
                              )}
                            </Radio.Group>
                          </div>
                        </Modal>

                        {addAgentFeedback === 1 &&
                          Number(qualityScore) < 100 && (
                            <div class="modalBtns">
                              <Button
                                className="audit-detail-buttons acceptFeedbackbtn defaultBtn"
                                onClick={onClickReview}
                              >
                                Feedback&nbsp;
                              </Button>
                            </div>
                          )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          )}{" "}
        </>
      )}
    </div>
  );
};
export default AuditView;
